import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../../components/DialogBoxComponent/DialogBox";
import Toast from "../../../components/ToastContainer/CustomToast";
import { getAllSites } from "../../../slices/Site/SiteSlice";
import { ThemeContext } from "../../../theme/ThemeContext";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      maxWidth: "600px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function SiteFilter(props) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [sites, setSites] = useState();
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const [isHovered, setIsHovered] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    name: "",
  });

  const payload = {
    page: 1,
    rowsPerPage: 10000,
    code: "",
    name: "",
  };

  const defaultFilter = {
    name: "",
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setFilterQuery({
      ...filterQuery,
      [name]: event.target.value,
    });
  };

  const onSelectChange = (event) => {
    setFilterQuery({
      ...filterQuery,
      parentId: event.id,
    });
  };

  const handleClose = () => {
    setFilterQuery(defaultFilter);
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleSubmit = () => {
    if (filterQuery.name.trim() === "") {
      Toast(t("COMMON015"), "error");
      return;
    }
    props.onSubmit(filterQuery);
    handleClose();
  };

  const handleOpen = () => {
    dispatch(getAllSites(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") setSites(data.data.site);
      });

    setOpen(true);
  };

  const reset = () => {
    // if (filterQuery.name.trim() === "") {
    //   Toast(t("COMMON027"), "error");
    //   return;
    // }
    // setFilterQuery(defaultFilter);
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setOpen(true)}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SiteFilter />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SiteFilter />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        // Header={t("COMMON006")}
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          justifyContent="center"
          alignItems={"center"}
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid item xs={12} sm={12}>
            <CustomTextfield
              label={t("COMMON044")}
              name="name"
              value={filterQuery.name}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
